<template>
  <v-card
    class="rounded-20 pb-2 px-2"
    @click.stop
    :ripple="false"
    style="cursor: default"
  >
    <v-card-title class="title-font font-weight-bold mb-1 pb-0">
      UPGRADE SUBSCRIPTION
    </v-card-title>
    <v-card-text class="py-0 px-4">
      <p class="black--text ma-0 mr-5 title-font">
        You've exhausted your
        {{ capitalise(item.product_code) }} credits! <br />Consider upgrading
        your subscription.
      </p>
      <v-carousel
        v-model="planIndex"
        light
        hide-delimiters
        :continuous="false"
        height="100%"
      >
        <v-carousel-item
          v-for="(plan, index) in plans"
          :key="index"
          class="ma-2"
        >
          <PricingCard
            :pricing="plan"
            :change="'UPGRADE'"
            :loading="loading"
            @selected="changeSubscription"
            class="pa-1"
          />
        </v-carousel-item>
      </v-carousel>
    </v-card-text>
  </v-card>
</template>

<style scoped>
.v-card--link:before {
  background: none;
}
</style>

<script>
import { mapActions, mapGetters } from "vuex"
import client from "@/lib/ApiClient"
import { capitalise } from "@/utils"
import PricingCard from "@/components/PricingPage/PricingCard.vue"

export default {
  props: ["item", "plans"],

  components: { PricingCard },

  data() {
    return {
      planIndex: 0,
      loading: false,
      selectedPlan: null
    }
  },

  computed: {
    ...mapGetters([""])
  },

  methods: {
    ...mapActions(["triggerReload", "setSubscription"]),

    capitalise,

    async changeSubscription(plan_code, schedule = false) {
      this.loading = true
      await client.gateway.billing.changeSubscription({
        plan_code,
        schedule
      })
      this.poll()
    },

    async poll() {
      const subscriptionResponse =
        await client.gateway.billing.subscriptionInformation()
      if (subscriptionResponse.activated) {
        // Polling for immediate upgrade, should it ever have schedule?
        this.setSubscription(subscriptionResponse)
        this.triggerReload("quotas")
        this.loading = false
        this.dialog = false
      } else return setTimeout(this.poll, 500)
    }
  }
}
</script>
